function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3.175 3.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.745 2.655c0 .019-.017.037-.035.055s-.036.036-.055.035c-.017.018-.056.017-.074.016L.884 2.685a.2.2 0 0 1-.197-.198c-.005-.113.067-.185.18-.18l1.244.056L.477.728A.19.174 45 0 1 .465.465.179.163 45 0 1 .594.414a.179.163 45 0 1 .135.063L2.364 2.11 2.308.867c-.005-.113.066-.185.18-.18a.2.2 0 0 1 .197.197l.076 1.697c0 .018.002.057-.016.074",
    style: {
      strokeWidth: 0.18829
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.0144713e88bf2a693fb377d5e137adb6.svg";
export { ForwardRef as ReactComponent };